import { createStore } from 'satcheljs';
import { FeedbackViewState } from './schema/FeedbackViewState';
import { FeedbackRibbonState } from './schema/FeedbackRibbonState';

var initialFeedbackViewState: FeedbackViewState = {
    subjectArea: '',
    emailAddresses: ['owareactmail@service.microsoft.com'],
    message: '',
    rating: 0,
    screenshotBlob: null,
    screenshotFileBase64: null,
};

var initialFeedbackRibbonState: FeedbackRibbonState = {
    showThankYouMessage: false,
};

export var store = createStore<FeedbackViewState>('feedbackViewState', initialFeedbackViewState)();

export let feedbackRibbonStore = createStore<FeedbackRibbonState>(
    'feedbackRibbonState',
    initialFeedbackRibbonState
);
